import { Link } from "react-router-dom";
import React from "react";



const TeamInvite = (props) => {
  function copyCode() {
   
    <div class="alert alert-primary" role ="alert"> hello </div>
    
  }
  return (
    <div className="container text-center" id="team-created-page">
      <div className="invisible">
            <div className="text-primary">
            ------------------------------------------
            ------------------------------------------
            ------------------------------------------
            ------------------------------------------
            ------------------------------------------
            ------------------------------------------
            ------------------------------------------
            ------------------------------------------
            ------------------------------------------
            ------------------------------------------
            ------------------------------------------
           
            </div>
          </div>
      <h1>Your team {props.teamName} was created!</h1>
      <div className="invisible">
            <div className="text-primary">
            ------------------------------------------
            ------------------------------------------
         
           
           
            </div>
          </div>
      <p>Invite users to join with the code</p>
      <h1>
        <code><div className="text-primary">{props.teamId} <button className = "btn btn-primary" onclick="copyCode()">Copy</button> </div></code>
        
      </h1>
      
      <div className="invisible">
            <div className="text-primary">
            ------------------------------------------
            ------------------------------------------
            ------------------------------------------
            ------------------------------------------
            ------------------------------------------
           
           
            </div>
          </div>
      <p>Or join using the link:</p>

      <h5>
        <Link to={"/jointeam/" + props.teamId} target="_blank">
          <div className="text-primary" text-decoration = "none">
          {"https://main--melodic-swan-71c046.netlify.app/jointeam/" +
            props.teamId} 
          </div> 
        </Link>
      </h5>
      <div className="invisible">
            <div className="text-primary">
            ------------------------------------------
            ------------------------------------------
            ------------------------------------------
            </div>
          </div>

      <Link to="/teams">
        <button type="submit" className="btn btn-primary">
          Back to Teams
        </button>
      </Link>
    </div>
  );
};

export default TeamInvite;
